<template lang="pug">
    DropDown.hzAutoComplete(ref="dropdown", @show="hoverIndex=-1", :disabled="disabled")
        template(slot="dropHead")
            input.hzFormElement(ref="ipt", :name="name", :required="required", :value="currentValue", type="text",
            @compositionstart="isListenInput=false", @compositionend="compositionend($event)", @input="_handleInput($event)", autocomplete="off", :style="iptStyle", @keydown.down.prevent="navigateOptions('next')", @keydown.up.prevent="navigateOptions('prev')", @keydown.enter.prevent="selectHoveredOption", @keydown.esc.stop.prevent="$refs.dropdown.hide()", :disabled="disabled")
        div(slot="dropBody", v-show="filterItems")
            ul.hzAutoCompleteUl
                template(v-for="(item, index) in filterItems")
                    li(@click="clickLi", :class="{hover: index === hoverIndex}") {{item}}
</template>

<script>
    import Keyupdown from './util/keyupdown'
    import DropDown from './dropdown'
    export default {
        name: 'hz-autocomplete',
        mixins: [Keyupdown],
        components: { DropDown },
        props: {
            value: String,
            items: null,
            name: null,
            required: { type: Boolean, default: null },
            maxLength: { type: Number, default: 8 },
            isCheck: { type: Boolean, default: true },
            multiple: { type: Boolean, default: false },
            iptStyle: null,
            disabled: { type: Boolean, default: false }
        },
        
        data() {
            return {
                isListenInput: true,
                currentValue: this.value,
                _timer: null
            }
        },
        
        computed: {
            //数组形式的value
            values() {
                console.log('value change：', this.currrent);
                if(!this.currentValue) {
                    return [];
                }
                let arr = this.currentValue.split(',').filter(one => one.trim()).slice(0, -1);

                if(this.isCheck) {
                    arr = arr.filter(one => this.items.indexOf(one) !== -1);
                }

                return arr;
            },

            filterItems() {
                if(!this.currentValue) {
                    return (this.items || []).slice(0, this.maxLength);
                }

                // 取出逗号后面最后一个不完整的值
                let index = this.currentValue.lastIndexOf(',');
                let lastValue = this.currentValue;
                if(index > -1) {
                    lastValue = $.trim(this.currentValue.slice(index + 1));
                }

                if(!lastValue) {
                    return [];
                }
                lastValue = lastValue.toLowerCase();
                
                let results = this.items.filter(one => {
                    let item = (one || '').toLowerCase();
                    return item.indexOf(lastValue) === 0 && (one === this.currentValue || this.values.indexOf(one) === -1);
                });

                return results.slice(0, this.maxLength)
            },
            
            itemsLength() {
                return this.filterItems.length;
            }
        },

        watch: {
            value() {
                this.$nextTick( e => {
                    this.currentValue = this.value;
                })
            },

            values(old, newValues) {
                if(old != newValues) {
                    this.$emit('change', this.values);
                }
            },

            items() {
                if(this.items && this.items.indexOf(this.currentValue) === -1) {
                    this.currentValue = '';
                }
            }
        },

        mounted() {
            //通过jquery或者hz.tools.form.fill设置值时使用
            this.$refs.ipt.onchange = this._handlerValueChange;
        },

        methods: {
            _handlerValueChange(e) {
                this.currentValue = e.target.value;
            },

            compositionend(event) {
                this.isListenInput = true;
                this._handleInput(event);
            },

            _handleInput(event) {
                if(this.isListenInput) {
                    var value = event.target.value;
                    this.currentValue = value;
                    this.$emit('input', this.currentValue);
                }
            },
            
            clickLi(e) {
                this._timer && clearTimeout(this._timer);
                let li = e.currentTarget;
                let value = li.innerText;
                if(this.values.indexOf(value) === -1) {
                    if(this.multiple) {
                        this.values.push(value);
                        this.currentValue = this.values.join(',');
                    }
                    else {
                        this.currentValue = value;
                    }
                }
                this.$refs.ipt.focus();
                this.$emit('input', this.currentValue);
            }
        }
    }
</script>

<style lang="stylus">
    .hzAutoComplete
        display inline-block
        position relative
        &:focus
            outline none
        input 
            width 100%
    
    .hzAutoCompleteUl
        li
            white-space nowrap
            line-height 30px
            padding 0 25px 0 10px
            cursor pointer
            font-size 12px
            position relative
            font-weight 500
            &:hover
                background-color #f0f0f0
            &.hover 
                background-color #3993ef
                color #fff
                    
</style>
            



// WEBPACK FOOTER //
// src/autoComplete.vue